import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import PropertyListing from "./pages/PropertyListing";
import PropertyDetails from "./pages/PropertyDetails";
import PropertySearchResult from "./pages/PropertySearchResult";
import International from "./pages/International";
import AboutUs from "./pages/AboutUs";
import Buying from "./pages/Buying";
import Selling from "./pages/Selling";
import Leasing from "./pages/Leasing";
import PortfolioManagement from "./pages/PortfolioManagement";
import Service from "./pages/Service";
import ContactUs from "./pages/ContactUs";
import ListYourProperty from "./pages/ListYourProperty";
import Developers from "./pages/Developers";
import OffPlanListing from "./pages/OffPlanListing";
import OffPlanAreaListing from "./pages/OffPlanAreaListing";
import OffPlanDetails from "./pages/OffPlanDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import "./App.css";

const templateScripts = [
  "/assets/js/vendor/jquery-3.7.1.min.js",
  "/assets/js/app.min.js",
  "/assets/js/nice-select.min.js",
  "/assets/js/wow.min.js",
  "/assets/js/main.js",
];

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const fullSrc = `${publicUrl}${src}`;
    const existing = document.querySelector(`script[data-bluewater-src="${src}"]`);

    if (existing?.dataset.loaded === "true") {
      resolve();
      return;
    }

    if (existing) {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = fullSrc;
    script.async = false;
    script.dataset.bluewaterSrc = src;
    script.addEventListener(
      "load",
      () => {
        script.dataset.loaded = "true";
        resolve();
      },
      { once: true }
    );
    script.addEventListener("error", reject, { once: true });
    document.body.appendChild(script);
  });
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  useEffect(() => {
    templateScripts.reduce((chain, src) => chain.then(() => loadScript(src)), Promise.resolve());
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties/:category" element={<PropertyListing />} />
        <Route path="/property-listing" element={<PropertyListing />} />
        <Route path="/property-listing.html" element={<PropertyListing />} />
        <Route path="/property-search-result" element={<PropertySearchResult />} />
        <Route path="/property-search-result.html" element={<PropertySearchResult />} />
        <Route path="/property-details" element={<PropertyDetails />} />
        <Route path="/property-details/:propertyId/*" element={<PropertyDetails />} />
        <Route path="/property-details.html" element={<PropertyDetails />} />
        <Route path="/international" element={<International />} />
        <Route path="/International.html" element={<International />} />
        <Route path="/international.html" element={<International />} />
        <Route path="/developers/:developerSlug/:developerId" element={<OffPlanListing />} />
        <Route path="/offplan-listing" element={<OffPlanListing />} />
        <Route path="/offplan-listing.html" element={<OffPlanListing />} />
        <Route path="/offplan-by-area" element={<OffPlanAreaListing />} />
        <Route path="/offplan-by-area/:areaSlug" element={<OffPlanAreaListing />} />
        <Route path="/offplan-details" element={<OffPlanDetails />} />
        <Route path="/offplan-details/:referenceNumber/*" element={<OffPlanDetails />} />
        <Route path="/offplan-details.html" element={<OffPlanDetails />} />
        <Route path="/developers" element={<Developers />} />
        <Route path="/developers.html" element={<Developers />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about-us.html" element={<AboutUs />} />
        <Route path="/buying" element={<Buying />} />
        <Route path="/Buying.html" element={<Buying />} />
        <Route path="/buying.html" element={<Buying />} />
        <Route path="/selling" element={<Selling />} />
        <Route path="/Selling.html" element={<Selling />} />
        <Route path="/selling.html" element={<Selling />} />
        <Route path="/leasing" element={<Leasing />} />
        <Route path="/Leasing.html" element={<Leasing />} />
        <Route path="/leasing.html" element={<Leasing />} />
        <Route path="/portfolio-management" element={<PortfolioManagement />} />
        <Route path="/Portfolio-Management.html" element={<PortfolioManagement />} />
        <Route path="/portfolio-management.html" element={<PortfolioManagement />} />
        <Route path="/services" element={<Service />} />
        <Route path="/service" element={<Service />} />
        <Route path="/Service.html" element={<Service />} />
        <Route path="/service.html" element={<Service />} />
        <Route path="/property-management" element={<Service />} />
        <Route path="/propertymanagement.html" element={<Service />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/contact-us.html" element={<ContactUs />} />
        <Route path="/list-your-property" element={<ListYourProperty />} />
        <Route path="/list-your-property.html" element={<ListYourProperty />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog.html" element={<Blog />} />
        <Route path="/blog/:blogSlug/:blogId" element={<BlogDetails />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog-details.html" element={<BlogDetails />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
